<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div class="modal-open-enduser-app scrollable -y">
      <div class="header">
        <div class="title">Registration is completed</div>
        <div class="description">Do you want to open your site now?</div>
      </div>
      <div class="body">
        <div class="content">
          <div class="action-btns flex-end">
            <div
            id="open-dealer-portal-go"
            v-on:click="goToEnduserApp()" ontouchstart=""
            class="action-btn blue">Open your site</div>
            <div
            id="open-dealer-portal-cancel"
            v-on:click="closeModalRequest()" ontouchstart=""
            class="action-btn">Cancel</div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'modal-open-enduser-app',
  components: {
    Modal
  },
  methods: {
    closeModalRequest: function () {
      this.$emit('closeModalRequest')
    },
    goToEnduserApp: function () {
      this.goToURL(this.$env.appWebUrl)
      this.closeModalRequest()
    },
    goToURL: function (url) {
      this.$tool.redirectToUrl(url)
    }
  }
}
</script>

<style scoped>
.modal-open-enduser-app {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  font-size: 11px;
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
}

.modal-open-enduser-app .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 32px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-open-enduser-app .header .title {
  /* common */
  font-size: 2em;
}
.modal-open-enduser-app .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}


.modal-open-enduser-app .error-message {
  /* common */
  background-color: hsla(0, 100%, 65%, 1);
  color: #fff;
  /* text */
  text-transform: uppercase;
  font-weight: bold;
  /* size */
  width: 100%;
  /* height: 3em; */
  padding: 1em 0;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


.modal-open-enduser-app .body {
  /* size */
  padding: 0 32px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}

.modal-open-enduser-app .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}


.modal-open-enduser-app .body .content .info-container:first-child {
  margin-top: 0;
}
.modal-open-enduser-app .body .content .info-container {
  /* size */
  margin: 1em 0;
}
.modal-open-enduser-app .body .content .info-container > input {
  /* common */
  background-color: hsla(0, 100%, 0%, 0.1);
  /* size */
  width: calc(100% - 1em);
  padding: 0.5em;
}





.modal-open-enduser-app .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1em;
}
.modal-open-enduser-app .body .content .action-btn {
  /* common */
  background-color: white;
  color: var(--gray-high);
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid var(--border);
  -webkit-box-shadow: 0 0 5px 0 rgba(227,232,238,.42745098039215684);
  box-shadow: 0 0 5px 0 rgba(227,232,238,.42745098039215684);
  /* size */
  width: auto;
  padding: 0.5em 1em;
  /* mouse */
  cursor: pointer;
}
.modal-open-enduser-app .body .content .action-btn.blue {
  /* common */
  background-color: var(--primary);
  color: #fff;
}
.modal-open-enduser-app .body .content .action-btn.red {
  /* common */
  background-color: var(--danger);
  color: #fff;
}
.modal-open-enduser-app .body .content .action-btn.dark {
  /* common */
  background-color: hsla(202, 0%, 10%, 1);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalOpenEnduserApp.vue